import React, { useEffect } from "react";
import notcartimg from "../images/approval.png";
import { NavLink } from "react-router-dom";
import { updateCartStatusApi } from "../services/Apis";
import { setcartlistdata } from "../redux/cartslice";
import { useDispatch,useSelector } from "react-redux";
const Ordersuccess = () => {
    // Get the current path from the URL
    const path = window.location.pathname;

    // Extract the last segment of the URL (the order ID)
    const orderId = path.split("/").pop();

    const dispatch = useDispatch()


    useEffect(() =>{
        updateCartStatusApi()
        dispatch(setcartlistdata({}))
    },[])

    return (
        <div className="notlogin">
            <img src={notcartimg} alt="Order Success" />
            <div className="notlogintitle">Your order was placed successfully.</div>
            <div className="notloginsubtitle">
                Your order number is <strong>{orderId}</strong>
            </div>
            <div className="d-flex">
                <NavLink to="/my-orders" className="success-vieworderbtn notloginbtn textdecoration-none me-3">
                    View your orders
                </NavLink>
                <NavLink to="/" className="notloginbtn textdecoration-none">
                    Keep exploring
                </NavLink>
            </div>
        </div>
    );
};

export default Ordersuccess;
